import Cookies from 'js-cookie'

const MemberTokenKey = 'vue_mobile_member_token'

export function getMemberToken() {
  return Cookies.get(MemberTokenKey);
  // return "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJVVUlEIjoiYjdjYjZmZWMtM2VhYy00YTI0LWI4NTMtNDM5MzRlYmI2YTgxIiwiVUlEIjoyLCJVc2VybmFtZSI6InRlc3QiLCJVc2VydHlwZSI6MCwiVGVuYW50SWQiOjAsIk5hbWUiOiJ0ZXN0IiwiU3R1ZGVudElkIjoxLCJCdWZmZXJUaW1lIjowLCJleHAiOjE3NDk0ODAwOTcsIm5iZiI6MTczMTMzNjA5N30.zY1Td5etjy0DhMytmVw_-Ho-MQ4vuh59WFnJ2fX3ums"
}
export function setMemberToken(token) {
  return Cookies.set(MemberTokenKey, token)
}

export function removeMemberToken() {
  return Cookies.remove(MemberTokenKey)
}

/**
 * @author Jonas
 * @date 2023/2/6 18:27:48
 * @description 复制对象，将dest中有的source的键复制到dest中
 */
export function copyObject(source, dest) {
  for (const key in dest) {
    if (source.hasOwnProperty(key)) {
      dest[key] = source[key];
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/auth.js